import { render, staticRenderFns } from "./useDetail.vue?vue&type=template&id=25a7e78e&scoped=true"
import script from "./useDetail.vue?vue&type=script&lang=js"
export * from "./useDetail.vue?vue&type=script&lang=js"
import style0 from "./useDetail.vue?vue&type=style&index=0&id=25a7e78e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7e78e",
  null
  
)

export default component.exports